/* eslint react-hooks/immutability: ["warn"] */
import { hasOngoingTask } from "@coworker/app/src/components/RoomSettings/Molecules/MediaArticles.helper";
import { Media } from "@coworker/app/src/components/RoomSettings/types/media";
import { TaskLinks } from "@coworker/app/src/components/RoomSettings/types/taskLink";
import { AggregatedItemListViewItem } from "@coworker/apprestructured/src/media-maintenance/components/aggregated-items/AggegatedItemListViewItem/AggregatedItemListViewItem";
import { ItemStockInfo } from "@coworker/apprestructured/src/shared/hooks/item/useItemStock";
import { Item } from "@coworker/apprestructured/src/shared/types/item";
import { AggregatedArticle } from "../hooks/useAggregatedArticles";
import "../styles/RoomSettings.css";
import { ArticleIdNbrArticles, EdsData, SalesStopData } from "../types/article";

interface AggregatedArticleListItemProps {
  article: AggregatedArticle;
  media: Media;
  itemInfo: Item | null;
  itemInfoLoading: boolean;
  taskLinks?: TaskLinks;
  v2TasksMap?: Map<string, boolean>;
  edsData?: EdsData | null;
  salesStopData?: SalesStopData | null;
  badges4AK1?: string[];
  itemTags?: string[];
  selectArticleIdsMode?: boolean;
  isSelected?: boolean;
  stockInfo?: ItemStockInfo;
  handleSelectedItems?: (articleIdNbrArticles: ArticleIdNbrArticles) => void;
}

export function AggregatedArticleListItem({
  article,
  edsData,
  salesStopData,
  badges4AK1,
  itemTags,
  selectArticleIdsMode,
  isSelected,
  handleSelectedItems,
  taskLinks,
  v2TasksMap,
  media,
  itemInfo,
  stockInfo,
  itemInfoLoading,
}: AggregatedArticleListItemProps) {
  const handleSelectedItemChange = () => {
    if (handleSelectedItems) {
      handleSelectedItems({
        articleId: article.id,
        nbrArticles: article?.nbrArticles || 0,
      });
    }
  };

  if (!article) return <></>;

  // Compute hasOngoingTasks from v1 taskLinks + v2 batch data
  const aggregatedArticleIds = article.aggregatedArticles.map((a) => a.id);
  const hasV1Tasks = hasOngoingTask(aggregatedArticleIds, taskLinks || []);
  // For Article List: show badge if item_no matches
  const hasV2Tasks = v2TasksMap?.get(article.productArticleId) || false;
  const hasOngoingTasks = hasV1Tasks || hasV2Tasks;

  return (
    <>
      <AggregatedItemListViewItem
        edsData={edsData ?? null}
        salesStopData={salesStopData ?? null}
        showActions={!selectArticleIdsMode}
        selectArticleIdsMode={selectArticleIdsMode}
        isSelected={isSelected || false}
        article={article}
        hasOngoingTasks={hasOngoingTasks}
        media={media}
        itemInfo={itemInfo}
        stockInfo={stockInfo}
        itemInfoLoading={itemInfoLoading}
        badges4AK1={badges4AK1 ?? article.badges4AK1 ?? []}
        itemTags={itemTags ?? article.itemTags ?? []}
        handleSelectedItemChange={handleSelectedItemChange}
      />
    </>
  );
}
